import React from 'react';
import { useLingui } from '@lingui/react';
// eslint-disable-next-line no-restricted-imports
import { Link, Group } from '@landr/maestro';
import { Link as ReactRouterLink } from 'react-router-dom';
import { FilterFamily } from 'types/generated/graphql';
import { RoutePaths } from 'types/enums';
import { SubFilterList } from './SubFilterList';

export const FilterList = ({
    filters,
    path,
}: {
    filters: FilterFamily[];
    path: RoutePaths;
}) => {
    const { i18n } = useLingui();

    return (
        <>
            {filters.map((filter) => {
                if (!path || !filter?.code) {
                    return null;
                }

                return (
                    <Group direction="vertical" gap="2xs" marginBottom="lg">
                        <Group.Item>
                            <Link
                                as={ReactRouterLink}
                                to={`/${path}/${filter.code}`}
                                color="text.base"
                                hasUnderline="hover"
                                fontWeight="bold"
                                fontSize="lg"
                            >
                                {i18n._(filter.code)}
                            </Link>
                        </Group.Item>
                        {!!filter.subFilters && (
                            <Group.Item>
                                <SubFilterList
                                    path={path}
                                    subFilters={filter.subFilters}
                                />
                            </Group.Item>
                        )}
                    </Group>
                );
            })}
        </>
    );
};
